import React from "react";
import "./App.css";
import ContactCards from "./ContactCards";
import Joke from "./Joke";
import jokesData from "./jokesData";

function App() {
  const jokeComponents = jokesData.map(joke => (
    <Joke key={joke.id} question={joke.question} answer={joke.answer} />
  ));
  return (
    <div className="App">
      {jokeComponents}
      <ContactCards
        contact={{
          imgUrl:
            "https://scontent.fdel3-1.fna.fbcdn.net/v/t1.0-9/26220289_1007720042731046_3906798058299411942_n.jpg?_nc_cat=103&_nc_ht=scontent.fdel3-1.fna&oh=f7ebe8cc8c5542db41878a5d9c0f4419&oe=5CCAE0DE",
          name: "Rohit",
          title: "Web Developer",
          description: "Hi, I am a React JS Developer"
        }}
      />
      <ContactCards
        contact={{
          imgUrl:
            "https://scontent.fdel3-1.fna.fbcdn.net/v/t1.0-9/26220289_1007720042731046_3906798058299411942_n.jpg?_nc_cat=103&_nc_ht=scontent.fdel3-1.fna&oh=f7ebe8cc8c5542db41878a5d9c0f4419&oe=5CCAE0DE",
          name: "Rohit",
          title: "",
          description: "Hi, I am a React JS Developer"
        }}
      />
    </div>
  );
}

export default App;
